import { render, staticRenderFns } from "./GChatBuyerInfoSp.vue?vue&type=template&id=2de9ab18&scoped=true&"
import script from "./GChatBuyerInfoSp.vue?vue&type=script&lang=ts&"
export * from "./GChatBuyerInfoSp.vue?vue&type=script&lang=ts&"
import style0 from "./GChatBuyerInfoSp.vue?vue&type=style&index=0&id=2de9ab18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de9ab18",
  null
  
)

export default component.exports